module.exports = __webpack_public_path__ + "static/img/xnts.81e9203.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/articleProject/images/xnts.jpg
// module id = x2MN
// module chunks = 5